/* global ENV */
import {
    createStore,
    applyMiddleware,
    compose,
} from 'redux';
import thunk from 'redux-thunk';
import localforage from 'localforage';
import selectors from './selectors/index';
import {rootReducer} from './reducers/index';
import {getInitialStore} from './store_utils';
import {setBookingId} from '@edreamsodigeo/frontend-tracking-agent';

const NOT_PERSIST_KEYS = {
    'user': true,
};

const connectedModels = [];
const connectedCollections = [];
let composeEnhancers;

try {
    composeEnhancers = ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;
} catch (e) {
    composeEnhancers = compose;
}

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

const getRestorableStore = (actualState) => {
    return {
        ...actualState,
        productSelection: {
            ...actualState.productSelection,
            products: actualState.productSelection.products.filter((item) => item.toBeRestored),
        },
    };
};

store.subscribe(() => {
    const shoppingCart = store.getState().shoppingCart;
    const bookingId = shoppingCart && shoppingCart.bookingId;
    bookingId && localforage.getItem(`store${bookingId}`).then((browserStore) => {
        const newStore = Object.assign({}, browserStore);
        const actualState = getRestorableStore(store.getState());
        const saveKey = (key) => {
            if (actualState[key] instanceof Promise) {
                actualState[key].then((value) => {
                    newStore[key] = value;
                    localforage.setItem(`store${bookingId}`, newStore);
                });
            } else {
                newStore[key] = actualState[key];
                localforage.setItem(`store${bookingId}`, newStore);
            }
        };
        Object.keys(actualState)
            .forEach((key) => {
                if (!NOT_PERSIST_KEYS[key]) {
                    saveKey(key);
                }
            });
        updateConnectedModels();
        connectedModels.forEach(mapStateToSelectors);
        localforage.setItem('bookingId', bookingId);
    });
    if (bookingId) {
        setBookingId(bookingId.toString());
    }
});

localforage.getItem('bookingId').then(getInitialStore).then((initialStore) => {
    dispatch({type: 'SET_INITIAL_STORE', entry: initialStore || {user: {}}});
});

const mapStateToSelectors = (modelClass) => {
    if (modelClass.selectors) {
        modelClass.selectors
            .forEach((selector) => {
                const selectorValue = selectors[selector](store.getState());
                if (selectorValue !== undefined || selectorValue !== null) {
                    modelClass.set(selector, selectorValue, {silent: modelClass.silentChange !== false});
                }
            });
        if (modelClass.onStoreChange) {
            modelClass.onStoreChange();
        }
        modelClass.trigger('change');
    }
};

export const connectModelRedux = (modelClass) => {
    mapStateToSelectors(modelClass);
    connectedModels.push(modelClass);
    return modelClass;
};

export const connectCollectionRedux = (collectionClass) => {
    connectedCollections.push(collectionClass);
    return collectionClass;
};

const updateConnectedModels = () => {
    connectedCollections.forEach((collection) =>
        collection.models
            .filter((model) => model.connect && !connectedModels.includes(model))
            .forEach((model) => connectedModels.push(model)));
};

const actionsQueue = [];
let storeInitialized = false;
export const getStore = () => store.getState();
export const dispatch = (action) => {
    if (typeof action !== 'function' && action.type === 'SET_INITIAL_STORE') {
        storeInitialized = true;
        store.dispatch(action);
        actionsQueue.forEach((action) => store.dispatch(action));
        actionsQueue.length = 0;
    } else {
        if (!storeInitialized) {
            actionsQueue.push(action);
        } else {
            store.dispatch(action);
        }
    }
};
